<script setup>
import WizardLayout from '@/Layouts/WizardLayout.vue';
import FormButton from '@/components/Shared/Form/Button.vue';
import {onBeforeMount, provide, ref} from 'vue';
import {router} from '@inertiajs/vue3';
import WizardSettings from '@/components/Dashboard/Wizard/WizardSettings.vue';

onBeforeMount(() => {
  provide('currentStep', 4);
});

const props = defineProps({
  integration: {
    type: Object,
    required: true,
  },
  application1: {
    type: Object,
    required: true,
  },
  application2: {
    type: Object,
    required: true,
  },
  flows: {
    type: Array,
    required: true,
  },
});

const settings = ref(null);
const processing = ref(false);

const submit = async () => {
  processing.value = true;

  const isSuccess = await settings.value.saveSettings();
  processing.value = false;

  if (isSuccess) {
    router.visit(route('wizard.step-5.index', {integration: props.integration.id}));
  }
};
</script>

<script>
import DashboardLayout from '@/Layouts/DashboardLayout.vue';

export default {
  layout: DashboardLayout,
};
</script>

<template>
  <wizard-layout>
    <template #default>
      <div class="wizard_grid">
        <h3 class="step-label">{{ trans('dashboard.integrations.wizard.step_x', {step: 4}) }} - {{ trans('dashboard.integrations.wizard.fourth_step.title') }}</h3>
        <p class="pt-2 pb-4">
          {{ trans('dashboard.integrations.wizard.fourth_step.description') }}
        </p>

        <wizard-settings
          v-if="integration && flows.length > 0"
          :flows="flows"
          :application-info1="application1.application"
          :application-info2="application2.application"
          :integration="integration"
          :user="$page.props.user"
          ref="settings"
        />
      </div>
    </template>
    <template #actions>
      <div class="grid-2 mt-2 relative z-10">
        <inertia-link
          class="button button_prev"
          :href="route('wizard.step-3.index', { integration: integration.id })"
          v-text="trans('pagination.previous')"
        />
        <form-button @click="submit" :value="trans('pagination.next')" :processing="processing" @submit="submit"/>
      </div>
    </template>
  </wizard-layout>
</template>
